import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { Button, ButtonGroup, useToast } from '@chakra-ui/react'
import { graphql } from '@/__generated__/gql'
import { Drawer } from '@/components/drawer'
import { UserForm, FormValues } from './components/user-form'

const createUserDocument = graphql(`
  mutation CreateUser($input: UserInput!) {
    createUser(input: $input) {
      message
      user {
        id
      }
    }
  }
`)

export function NewUserRoute() {
  const navigate = useNavigate()
  const toast = useToast()
  const onClose = useCallback(() => navigate('..'), [navigate])

  const [createUser, { loading: submitting }] = useMutation(
    createUserDocument,
    {
      refetchQueries: ['Users'],
      onCompleted(data) {
        toast({
          status: 'success',
          title: data.createUser.message,
          isClosable: true,
        })
        onClose()
      },
      onError(error) {
        toast({
          status: 'error',
          title: error.message,
          isClosable: true,
        })
      },
    }
  )

  const onSubmit = useCallback(
    async (input: FormValues) => {
      await createUser({ variables: { input } })
    },
    [createUser]
  )

  return (
    <Drawer
      title="Ny bruker"
      onClose={onClose}
      footer={
        <ButtonGroup>
          <Button onClick={onClose}>Avbryt</Button>
          <Button
            form="user-form"
            type="submit"
            colorScheme="blue"
            isLoading={submitting}
          >
            Opprett bruker
          </Button>
        </ButtonGroup>
      }
    >
      <UserForm
        onSubmit={onSubmit}
        defaultValues={{
          mobile: '+47',
        }}
      />
    </Drawer>
  )
}
